module.exports = __webpack_public_path__ + "img/cnh.309e3efb.svg";